import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Rótulos pt-BR das ações conhecidas de platform_admin_audit_log; uma ação nova (ainda
// sem rótulo mapeado) cai no fallback e mostra o próprio código.
export const AUDIT_ACTION_LABELS = {
  'backups.download': 'Download de backup',
  'company.delete': 'Exclusão de empresa',
  'company.demo_data_removed': 'Dados de exemplo removidos',
  'company.demo_data_seeded': 'Dados de exemplo criados',
  'company.reopen_trial': 'Novo período de teste',
  'company.referral_confirm': 'Indicação confirmada',
  'company.referral_reward': 'Crédito de indicação',
  'company.set_test': 'Flag de teste',
  'crons.run_now': 'Rotina disparada',
  'feedback.set_status': 'Status de feedback',
  'nps.set_status': 'Status de NPS',
  'security.unblock_ip': 'Liberação de IP',
};

/**
 * AuditActionChip - Indicador da ação registrada em uma linha de auditoria (Admin Geral > Auditoria)
 *
 * Mesmo padrão visual (neutro, sem paleta nova) de LogChannelChip, já que a lista de
 * ações pode crescer e não há uma cor natural por ação.
 *
 * @param {Object} props
 * @param {string} props.action
 */
function AuditActionChip({ action }) {
  const label = AUDIT_ACTION_LABELS[action] || action || '—';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: '#E3F2FD',
        border: '1px solid #BBDEFB',
        width: 'fit-content',
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: '#1565C0', whiteSpace: 'nowrap' }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default AuditActionChip;
